import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { INTEGRATION_CONNECTIONS } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list integration Connection.
 * @returns {Promise} - A promise that resolves with the list of integration Connection or rejects with an error.
 * @param props
 */
export const listIntegrationConnection = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
  integrationSystem,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${INTEGRATION_CONNECTIONS.replace('{integrationSystemId}', doubleEncode(integrationSystem?.IntegrationId))}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    integrationConnections: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create integration Connection.
 * @returns {Promise} - A promise that resolves with the creation of test or rejects with an error.
 * @param data
 */
export const createIntegrationConnection = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_CONNECTIONS.replace('{integrationSystemId}', doubleEncode(data?.IntegrationId))}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update integration Connection.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const updateIntegrationConnection = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  let integrationId = doubleEncode(data?.IntegrationId);
  let connectionId = doubleEncode(data?.ConnectionId);
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_CONNECTIONS.replace('{integrationSystemId}', integrationId)}/${connectionId}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete integration Connection.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const deleteIntegrationConnection = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  let integrationId = doubleEncode(data?.IntegrationId);
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_CONNECTIONS.replace('{integrationSystemId}', integrationId)}?connectionId=${data?.ConnectionId}&integrationId=${data?.IntegrationId}&tenantId=${data?.TenantId}&sysType=${data?.SysType}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get integration Connection.
 * @returns {Promise} - A promise that resolves with the integration Connection or rejects with an error.
 * @param data
 */
export const getIntegrationConnection = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  let integrationId = doubleEncode(data?.IntegrationId);
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_CONNECTIONS.replace('{integrationSystemId}', integrationId)}?connectionId=${data?.ConnectionId}&integrationId=${data?.IntegrationId}&tenantId=${data?.TenantId}&sysType=${data?.SysType}&includeSettings=true`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
